import { EMAIL, IN_APP } from 'constants/messageMediums';
import { getTemplateHasContent } from 'modules/campaigns/editor/components/utils';
import { MessageMedium } from 'constants/messageMediums';
import { ResourceType } from '../../types';
import { useGetTemplateData } from './hooks/useGetTemplateData';
import { MobilePreview } from './MobilePreview';
import { EmailPreview } from './EmailPreview';
import { EmptyTemplatePreview } from './EmptyTemplatePreview';
import {
  EmailPreviewContainer,
  EmptyTemplatePreviewContainer,
  MobilePreviewContent,
  MobilePreviewContainer,
  StyledMobilePreview,
  ResourcePreviewContainer,
} from './PreviewCard.styled';
import {
  MAX_PREVIEW_WIDTH,
  IN_APP_PREVIEW_WIDTH,
  IN_APP_PREVIEW_HEIGHT,
  MOBILE_PREVIEW_WIDTH,
  MOBILE_PREVIEW_HEIGHT,
} from './PreviewCard.constants';

type PreviewCardProps = {
  resourceType: ResourceType | string;
  resource?: {
    messageMedium?: string;
    templateId?: number;
  };
};

export const PREVIEW_TEST_ID = 'resource-preview-card';

/** Component for displaying a read-only preview for a resource in a card
 *  Only supports Campaigns and Templates
 */
export const PreviewCard = ({ resource }: PreviewCardProps) => {
  const { messageMedium, templateId } = resource || {};
  const { templateData, isLoading: isTemplateDataLoading } = useGetTemplateData(templateId);

  const hasTemplateContent = !!messageMedium
    ? getTemplateHasContent(messageMedium as MessageMedium, templateData)
    : true;

  switch (true) {
    case !!messageMedium && !hasTemplateContent && !isTemplateDataLoading:
      return (
        <EmptyTemplatePreviewContainer data-medium={messageMedium}>
          <EmptyTemplatePreview messageMedium={messageMedium} />
        </EmptyTemplatePreviewContainer>
      );

    case messageMedium === EMAIL && !!templateId:
      return (
        <EmailPreviewContainer data-test={`${PREVIEW_TEST_ID}-${messageMedium}`}>
          <EmailPreview
            templateId={templateId}
            templateData={templateData}
            isTemplateDataLoading={isTemplateDataLoading}
          />
        </EmailPreviewContainer>
      );

    case messageMedium === IN_APP && !!templateId:
      return (
        <ResourcePreviewContainer data-test={`${PREVIEW_TEST_ID}-${messageMedium}`}>
          <MobilePreviewContent>
            <StyledMobilePreview
              templateId={templateId}
              messageMedium={messageMedium}
              maxWidth={MAX_PREVIEW_WIDTH}
              previewWidth={IN_APP_PREVIEW_WIDTH}
              previewHeight={IN_APP_PREVIEW_HEIGHT}
            />
          </MobilePreviewContent>
        </ResourcePreviewContainer>
      );

    case !!messageMedium && !!templateId:
      return (
        <MobilePreviewContainer data-test={`${PREVIEW_TEST_ID}-${messageMedium}`}>
          <MobilePreviewContent>
            <MobilePreview
              templateId={templateId}
              messageMedium={messageMedium}
              maxWidth={MAX_PREVIEW_WIDTH}
              previewWidth={MOBILE_PREVIEW_WIDTH}
              previewHeight={MOBILE_PREVIEW_HEIGHT}
            />
          </MobilePreviewContent>
        </MobilePreviewContainer>
      );

    // Not supported yet
    // case resourceType === ResourceType.Journey:
    //   return (
    //     <ResourcePreviewContainer data-test={`${PREVIEW_TEST_ID}-${resourceType}`}>
    //       Journey preview
    //     </ResourcePreviewContainer>
    //   );

    default:
      return null;
  }
};
